<template>
    <div class="sag-modal">
        <b-modal id="smodal" ref="modalRef" title="BootstrapVue">
            <p class="my-4">Hello from modal!</p>
        </b-modal>
    </div>
</template>

<script>
import { BModal } from 'bootstrap-vue'
import { ref, onMounted, watch, computed } from '@vue/composition-api'
import tools from '@/sag-core/tools'
export default {
    components: {
        BModal
    },
    props: {
        toshow: {
            type: Boolean,
            default: false
        }
    },
    setup(props, ctx){
        const modalRef = ref(null)
        const show = ref(props.toshow)

        watch(show, (nval, oval)=>{
            ctx.emit('showChange', show.value)
        })
        onMounted(()=>{
            
        })

        return {
            modalRef, 
        }
    }
}
</script>
<style lang="scss">
.phidden {
    display: none;
}
</style>